// removed by extract-text-webpack-plugin
module.exports = {"switches":"qempo_Notifications_switches-3QJGBMW","dualWrap":"qempo_Notifications_dualWrap-2Wp6BWv","option":"qempo_Notifications_option-UG-WEFh","lastSection":"qempo_Notifications_lastSection-2W-ppVU","tooltip":"qempo_Notifications_tooltip--00GZmO","subtitle":"qempo_Notifications_subtitle-3kL9lg6"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/preferences/notifications/components/Notifications.scss
// module id = 1406
// module chunks = 0